import { Injectable } from '@angular/core';
import { BasketItem } from '@shared/services/cart/api-basket.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, pluck } from 'rxjs/operators';
import { ShoppingCart, UserInterface } from '@modules/ecommerce/shared/models';

export interface State {
  user: UserInterface;
  cart: ShoppingCart;
  items: BasketItem[];
}

const state: State = {
  user: undefined,
  cart: undefined,
  items: undefined,
};

@Injectable()
export class Store {
  private subject = new BehaviorSubject<State>(state);
  // private store = this.subject.asObservable().pipe(distinctUntilChanged());
  private store$  = this.subject.asObservable(); 

  get value() {
    return this.subject.value;
  }

  set(name: string, _state: any) {
    this.subject.next({
      ...this.value, [name]: _state
    });
  }

  select<K extends keyof State>(name: K): Observable<State[K]> {
    return this.store$.pipe(
      pluck(name),
      distinctUntilChanged()
    ) as Observable<State[K]>;
  }
}
